<section class="redirect-apps">
	<section class="redirect-apps__body">
		<header class="redirect-apps__header">
			<h1 class="redirect-apps__title">Continuar en la App</h1>
		</header>

		<main class="redirect-apps__content">
			<p *ngIf="applicantName" class="redirect-apps__message">
				Estimado {{ applicantName.name }} {{ applicantName.firstSurname }}, tu
				ya eres socio de caja morelia Valladolid, para realizar tu inversión,
				solo debes descargar tu aplicación CMV+ en tu tienda y acceder
			</p>
			<section class="redirect-apps__stores">
				<a
					href="https://apps.apple.com/mx/app/cmv-finanzas/id1459928515"
					target="_blank">
					<img src="./assets/images/app-stores/appstore-logo.svg" alt="" />App
					Store
				</a>
				<a
					href="https://play.google.com/store/apps/details?id=mx.com.cmv.finanzas"
					target="_blank">
					<img
						src="./assets/images/app-stores/playstore-logo.svg"
						alt="" />PlayStore
				</a>
				<a href="https://appgallery.huawei.com/app/C108882469" target="_blank">
					<img src="./assets/images/app-stores/appgallery-logo.svg" alt="" />App
					Gallery
				</a>
			</section>
			<button class="redirect-apps__accept-button" (click)="onAccept()">
				Aceptar
			</button>
		</main>
	</section>
</section>
